/**
 * DocuMind 前端应用入口
 *
 * 职责：
 * - 创建 Vue 应用实例
 * - 注册全局插件：Pinia（状态管理）、Vue Router（路由）、Element Plus（UI 组件库）
 * - 全局注册 Element Plus 图标组件，以便在模板中直接使用图标名
 * - 挂载应用到 DOM 根节点 #app
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import './assets/styles.css'

/* 创建 Vue 应用实例 */
const app = createApp(App)

/* 注册 Pinia 状态管理 */
app.use(createPinia())

/* 注册 Vue Router 路由 */
app.use(router)

/* 注册 Element Plus UI 组件库（locale: undefined 表示使用默认英文，后续可切换为中文） */
app.use(ElementPlus, { locale: undefined })

/* 全局注册所有 Element Plus 图标组件，模板中可直接用 <Edit /> 等 */
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

/* 将应用挂载到 HTML 中的 #app 节点 */
app.mount('#app')
